import React from 'react'
import { Alert } from 'antd'

const ErrorAlert = ({ error }) => {
  return (
    <div className="error-container">
      <Alert
        message="Error Loading Overrides"
        description={
          <div>
            <p>We encountered a problem loading the override data. {error}</p>
            <p>Please try refreshing the page. If the problem persists, contact support.</p>
          </div>
        }
        type="error"
        showIcon
      />
    </div>
  )
}

export default ErrorAlert
